import { render, staticRenderFns } from "./VPasswordChangeSuccess.vue?vue&type=template&id=6945b7c1&scoped=true&"
import script from "./VPasswordChangeSuccess.vue?vue&type=script&lang=js&"
export * from "./VPasswordChangeSuccess.vue?vue&type=script&lang=js&"
import style0 from "./VPasswordChangeSuccess.vue?vue&type=style&index=0&id=6945b7c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6945b7c1",
  null
  
)

export default component.exports